import React from "react"

import { useClick } from "../hooks/useClick"
import { useData } from "../hooks/useData"
import { useHeader } from "../hooks/useHeader"
import { useSelect } from "../hooks/useSelect"
import { useVariants } from "../hooks/useVariants"
import { Row, TableDataCells, TableHeadCells } from "../styled"

/**
 * A collapsible table that has a single col with each header followed by all row fields
 */
export function ColTable() {
  const { data, firstRow } = useData()
  const { onRowClick, onCellClick } = useClick()
  const { selectedRowMap, onSelect } = useSelect()
  const { headers } = useHeader()
  const variantData = useVariants()

  const handleRowClick = (event, data, row) => {
    if (onRowClick) {
      onRowClick({ data, row }, event)
    }

    if (onSelect) {
      onSelect({ row, data, selected: !Boolean(selectedRowMap[row]) }, event)
    }
  }

  const handleCellClick = (event, data, row, cell) => {
    if (onCellClick) {
      onCellClick({ data, row, cell }, event)
    }
  }

  const allData = firstRow && Array.isArray(firstRow) ? [firstRow, ...data] : data
  const numRows = allData.length
  const numCols = (allData && allData[0].length) || 0
  const rows = []

  for (let i = 0; i < numCols; i++) {
    if (headers[i]) {
      rows.push(
        <Row {...variantData} $isHeader key={`header_${i}`}>
          <TableHeadCells scope="col">{headers[i]}</TableHeadCells>
        </Row>,
      )
    }

    for (let j = 0; j < numRows; j++) {
      rows.push(
        <Row
          key={`row_${i}_${j}`}
          onClick={(e) => handleRowClick(e, allData[j], j)}
          selected={selectedRowMap[j]}
          {...variantData}
        >
          <TableDataCells onClick={(e) => handleCellClick(e, allData[j][i], j, i)}>{allData[j][i]}</TableDataCells>
        </Row>,
      )
    }
  }

  return (
    <table role="grid">
      <tbody>{rows}</tbody>
    </table>
  )
}
